<template>
	<div :style="{ width: '100%', height }" ref="pieChart"></div>
</template>

<script>
	import * as echarts from 'echarts'
	export default {
		name: 'PieChart',
		props: {
			title: {
				type: String,
				default: ''
			},
			data: {
				type: Array,
				default: () => []
			},
			height: {
				type: String,
				default: '350px'
			},
			showLegend: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				chartInstance: null
			}
		},
		watch: {
			data: {
				handler() {
					this.initChart()
				},
				deep: true
			},
			title() {
				this.initChart()
			}
		},
		mounted() {
			this.initChart()
			window.addEventListener('resize', this.handleResize)
		},
		beforeUnmount() {
			this.chartInstance?.dispose()
			window.removeEventListener('resize', this.handleResize)
		},
		methods: {
			initChart() {
				if (!this.$refs.pieChart) return
				if (!this.chartInstance) {
					this.chartInstance = echarts.init(this.$refs.pieChart)
					this.chartInstance.on('click', params => {
						if (params && params.data && params.data.id !== undefined) {
							this.$emit('sector-click', params.data.id)
						}
					})
				}
				const option = {
					title: {
						text: this.title,
						left: 'center',
						top: 10,
						textStyle: {
							fontSize: 14
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					legend: this.showLegend ? {
						orient: 'vertical',
						left: 'left'
					} : undefined,
					series: [{
						name: this.title,
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: false,
						padAngle: 5,
						itemStyle: {
							borderRadius: 10
						},
						label: {
							formatter: '{b}({c})',
						},
						data: this.data,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				}
				this.chartInstance.setOption(option)
			},
			handleResize() {
				this.chartInstance?.resize()
			}
		}
	}
</script>